var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{attrs:{"app":"","right":"","clipped":"","width":"290"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_c('perfect-scrollbar',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"mt-4 mx-2"},[(_vm.isCalendarView)?_c('calendar-date-selection'):_c('date-selection')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }